(function () {
  'use strict';

  var VERSION = 'WHOLESALE_LEAD_TRACKING_CANDIDATE_V1';
  var STATE_TRANSITIONS = {
    INTENT: ['CONTACTED'],
    CONTACTED: ['VALID_LEAD'],
    VALID_LEAD: ['QUOTED', 'LOST'],
    QUOTED: ['WON', 'LOST'],
    WON: [],
    LOST: []
  };
  var REQUIRED_EVIDENCE = {
    CONTACTED: 'contact_evidence',
    VALID_LEAD: 'qualification_evidence',
    QUOTED: 'quote_evidence',
    WON: 'order_evidence',
    LOST: 'outcome_evidence'
  };
  var PACKS = {
    MOBILE_STORE_45: {
      label: 'Paquete para tienda de accesorios',
      total_pieces: 45,
      wholesale_total_mxn: 1265,
      items: [
        { sku: 'XC05', quantity: 5 },
        { sku: 'CBC100', quantity: 10 },
        { sku: 'CBPD27W', quantity: 10 },
        { sku: 'CB410', quantity: 20 }
      ]
    },
    RESELLER_START_40: {
      label: 'Paquete inicial para revender',
      total_pieces: 40,
      wholesale_total_mxn: 1625,
      items: [
        { sku: 'CB410', quantity: 20 },
        { sku: 'CBC100', quantity: 10 },
        { sku: 'TWS500', quantity: 5 },
        { sku: 'E70', quantity: 5 }
      ]
    },
    AUDIO_CHARGING_25: {
      label: 'Paquete Audio + Carga',
      total_pieces: 25,
      wholesale_total_mxn: 1810,
      items: [
        { sku: 'TWS500', quantity: 5 },
        { sku: 'E70', quantity: 5 },
        { sku: 'XC05', quantity: 5 },
        { sku: 'CBC100', quantity: 10 }
      ]
    },
    TRAVEL_ENERGY_20: {
      label: 'Paquete Energía para viaje',
      total_pieces: 20,
      wholesale_total_mxn: 1745,
      items: [
        { sku: 'LY-10', quantity: 5 },
        { sku: 'XC05', quantity: 5 },
        { sku: 'CBC100', quantity: 10 }
      ]
    }
  };
  var PII_KEYS = ['name', 'email', 'phone', 'whatsapp_number', 'address', 'message'];

  function createLeadRef() {
    var bytes = new Uint8Array(10);
    if (window.crypto && window.crypto.getRandomValues) {
      window.crypto.getRandomValues(bytes);
    } else {
      for (var i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
    }
    return 'lr_' + Date.now().toString(36) + '_' + Array.prototype.map.call(bytes, function (value) {
      return value.toString(16).padStart(2, '0');
    }).join('');
  }

  function compact(value) {
    if (Array.isArray(value)) return value.map(compact);
    if (value && typeof value === 'object') {
      return Object.keys(value).reduce(function (output, key) {
        if (PII_KEYS.indexOf(key.toLowerCase()) === -1 && value[key] !== '' && value[key] != null) {
          output[key] = compact(value[key]);
        }
        return output;
      }, {});
    }
    return value;
  }

  function utmContext() {
    var params = new URLSearchParams(window.location.search);
    return ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].reduce(function (result, key) {
      var value = params.get(key);
      if (value) result[key] = value;
      return result;
    }, {});
  }

  function buildIntent(element) {
    var packId = element.dataset.packId || '';
    var pack = PACKS[packId] || null;
    return compact({
      schema: 'mishop.wholesale_intent.v1',
      lead_ref: createLeadRef(),
      state: 'INTENT',
      occurred_at: new Date().toISOString(),
      sku: element.dataset.sku || '',
      variant: element.dataset.variant || '',
      quantity: Number(element.dataset.quantity || (pack && pack.total_pieces) || 1),
      pack_id: packId,
      pack_label: pack && pack.label,
      sku_list: pack && pack.items,
      total_pieces: pack && pack.total_pieces,
      wholesale_total_mxn: pack && pack.wholesale_total_mxn,
      source_page: window.location.pathname,
      source: element.dataset.source || 'theme',
      cta_position: element.dataset.ctaPosition || 'unknown',
      channel: element.dataset.channel || 'mayoreo',
      purchase_mode: element.dataset.purchaseMode || 'reventa',
      utm: utmContext()
    });
  }

  function whatsappMessage(payload) {
    var lines = [
      'Hola, quiero cotizar: ' + (payload.pack_label || payload.sku || 'productos de mayoreo'),
      payload.pack_id ? 'Pack ID: ' + payload.pack_id : '',
      payload.total_pieces ? 'Piezas: ' + payload.total_pieces : '',
      payload.sku_list ? 'SKU: ' + payload.sku_list.map(function (item) { return item.sku + ' x' + item.quantity; }).join(', ') : '',
      'Referencia: ' + payload.lead_ref,
      'Sujeto a disponibilidad.'
    ];
    return lines.filter(Boolean).join('\n');
  }

  function emitIntent(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'mishop_wholesale_intent', wholesale_intent: payload });
    document.dispatchEvent(new CustomEvent('mishop:wholesale-intent', { detail: payload }));
    try {
      sessionStorage.setItem('mishop_last_wholesale_intent', JSON.stringify(payload));
    } catch (error) {
      /* The CTA remains usable when storage is blocked. */
    }
  }

  function transitionLead(currentState, nextState, evidence) {
    var allowed = STATE_TRANSITIONS[currentState] || [];
    if (allowed.indexOf(nextState) === -1) throw new Error('Invalid lead state transition');
    var required = REQUIRED_EVIDENCE[nextState];
    if (required && (!evidence || !evidence[required])) throw new Error('Missing evidence: ' + required);
    return { state: nextState, transitioned_at: new Date().toISOString(), evidence_type: required || null };
  }

  document.addEventListener('click', function (event) {
    var cta = event.target.closest('[data-mishop-lead-cta]');
    if (!cta) return;
    var payload = buildIntent(cta);
    emitIntent(payload);
    if (payload.channel === 'whatsapp' && cta.tagName === 'A') {
      cta.href = 'https://wa.me/523325063688?text=' + encodeURIComponent(whatsappMessage(payload));
    }
  });

  window.MishopWholesaleLeadTracking = Object.freeze({
    version: VERSION,
    packs: PACKS,
    buildIntent: buildIntent,
    transitionLead: transitionLead
  });
}());
